export default __webpack_public_path__ + "static/media/loading.6e352669.svg";